<style lang="scss" scoped>
.is-invalid {
  .el-input__inner {
    border-color: #dc3545;
  }

  &::v-deep .el-input__inner {
    border-color: #dc3545;
  }

  ::v-deep .el-input__inner {
    border-color: #dc3545;
  }
}

.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <el-date-picker
      v-model="modelValue"
      @input="$emit('input', $event)"
      type="date"
      placeholder="Datum auswählen"
      value-format="yyyy-MM-dd"
      format="dd.MM.yyyy"
      :class="{ 'is-invalid': hasErrors }"
    >
    </el-date-picker>
    <div
      v-if="attribute.errors !== null"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
import { DatePicker } from 'element-ui';

export default {
  components: {
    [DatePicker.name]: DatePicker
  },
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      modelValue: this.value
    };
  },
  computed: {
    colClass() {
      const col = this.attribute.col !== undefined ? this.attribute.col : 12;
      return `col-${col}`;
    },
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    type() {
      return this.attribute.type;
    }
  }
}
</script>
